function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKOWNNFT opcode — verify NFT ownership via witness utxokeys.
 */

module.exports = {
  name: 'CHECKOWNNFT',
  description: 'Verify NFT belongs to self via utxokeys',
  exampleScript: {
    op: 'CHECKOWNNFT',
    nftid: '<nftid>',
    witness: {
      utxokey1: '<utxokey1>',
      utxokey2: '<utxokey2>',
      utxokey3: '<utxokey3>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var tx = context.tx;
    if (!tx || !Array.isArray(tx.from) || tx.from.length === 0) {
      return false;
    }
    var nftid = node.nftid;
    if (typeof nftid !== 'string' || nftid.length === 0) {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var utxokey1 = witness.utxokey1;
    var utxokey2 = witness.utxokey2;
    var utxokey3 = witness.utxokey3;
    if (typeof utxokey1 !== 'string' || utxokey1.length === 0 || typeof utxokey2 !== 'string' || utxokey2.length === 0 || typeof utxokey3 !== 'string' || utxokey3.length === 0) {
      return false;
    }
    return true;
  }
};